/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".button-icon[_ngcontent-%COMP%]{position:relative;top:1px;left:2px;right:0;height:40px;width:40px}.mat-icon[_ngcontent-%COMP%]{font-size:24px!important}.mat-form-field-infix[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}input.mat-input-element[_ngcontent-%COMP%]{position:relative;top:5px}\n/*# sourceMappingURL=file-field.component.css.map*/"];
export { styles as styles };
